var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"md":12}},[_c('v-text-field',{attrs:{"label":"Name","required":""},model:{value:(_vm.editFolder.name),callback:function ($$v) {_vm.$set(_vm.editFolder, "name", $$v)},expression:"editFolder.name"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }